import React, { Component } from "react";
import { Link } from 'react-router-dom';
import ScrollToTop from 'react-scroll-up';
import { FiChevronUp } from "react-icons/fi";
import Helmet from "../component/common/Helmet";


import Header from "../component/header/Header";
import FooterTwo from "../component/footer/FooterTwo";




const Portfolio_image = <img src="/assets/images/portfolio/mockups/Navya/Navya-mockup-1.jpg" alt="React Creative Agency" />;
const Portfolio_image2 = <img src="/assets/images/portfolio/mockups/Navya/Navya-mockup-10.jpg" alt="React Creative Agency" />;
const Portfolio_image3 = <img src="/assets/images/portfolio/mockups/Navya/Navya-mockup-2.jpg" alt="React Creative Agency" />;
const Portfolio_image4 = <img src="/assets/images/portfolio/mockups/Navya/Navya-mockup-4.jpg" alt="React Creative Agency" />;
const Portfolio_image5 = <img src="/assets/images/portfolio/mockups/Navya/Navya-mockup-5.jpg" alt="React Creative Agency" />;
const Portfolio_image6 = <img src="/assets/images/portfolio/mockups/Navya/Navya-mockup-6.jpg" alt="React Creative Agency" />;

const PortfolioList = [
    {
        image: Portfolio_image,
        category: 'Cartoon Mockup',
        title: 'Jaya Rice',
        description: 'Professional lightweight, simple envelopes meant for the everyday mailings'
    },
    {
        image: Portfolio_image2,
        category: 'Christmas Golden Eve',
        title: 'Matta Vadi Rice',
        description: 'Promotional and corporate T shirts for employees'
    },
    {
        image: Portfolio_image3,
        category: 'Christmas & New Year Hamper',
        title: 'Chakki Fresh Atta Front',
        description: 'Professional Employee Photo ID cards with double side printed and display more info.'
    },
    {
        image: Portfolio_image4,
        category: 'Navya Fiesta Cake',
        title: 'Chakki Fresh Atta Back',
        description: 'Professional Employee Photo ID cards makes customers to know your employees'
    },
    {
        image: Portfolio_image5,
        category: 'English Fruit Cake',
        title: 'Appam Idiyappam Pathiri Podi',
        description: 'Professional Employee Photo ID cards with double side printed and display more info.'
    },
    {
        image: Portfolio_image6,
        category: 'Traditional Cake',
        title: 'Appam Idiyappam Pathiri Podi Back',
        description: 'Professional Employee Photo ID cards makes customers to know your employees'
    },
]







const Portfolio_image8 = <img src="/assets/images/portfolio/mockups/Navya/Navya-mockup-7.jpg" alt="React Creative Agency" />;
const Portfolio_image9 = <img src="/assets/images/portfolio/mockups/Navya/Navya-mockup-8.jpg" alt="React Creative Agency" />;
const Portfolio_image10 = <img src="/assets/images/portfolio/mockups/Navya/Navya-mockup-3.jpg" alt="React Creative Agency" />;
const Portfolio_image11 = <img src="/assets/images/portfolio/mockups/Navya/Navya-mockup-9.jpg" alt="React Creative Agency" />;
const Portfolio_image12 = <img src="/assets/images/portfolio/mockups/Navya/Navya-mockup-11.jpg" alt="React Creative Agency" />;
const Portfolio_image13 = <img src="/assets/images/portfolio/mockups/Navya/Navya-mockup-12.jpg" alt="React Creative Agency" />;

const PortfolioList1 = [
    {
        image: Portfolio_image8,
        category: 'Christmas Gift Box',
        title: 'Appam Idiyappam Pathiri Podi',
        description: "The business card represents the company's brand and the first exposure to the overall image"
    },
    {
        image: Portfolio_image9,
        category: 'Rich Plum Cake',
        title: 'Appam Idiyappam Pathiri Podi Back',
        description: "The business card represents the company's brand and the first exposure to the overall image"
    },
    {
        image: Portfolio_image10,
        category: 'Celebration Cake',
        title: 'Jaya Rice Back',
        description: 'Professional lightweight, simple envelopes meant for the everyday mailings'
    },
    {
        image: Portfolio_image11,
        category: 'Christmas Gift Box',
        title: 'Appam Idiyappam Pathiri Podi',
        description: "The business card represents the company's brand and the first exposure to the overall image"
    },
    {
        image: Portfolio_image12,
        category: 'Rich Plum Cake',
        title: 'Appam Idiyappam Pathiri Podi Back',
        description: "The business card represents the company's brand and the first exposure to the overall image"
    },
    {
        image: Portfolio_image13,
        category: 'Celebration Cake',
        title: 'Jaya Rice Back',
        description: 'Professional lightweight, simple envelopes meant for the everyday mailings'
    },

]


class InteriorLanding extends Component{


    stickyHeader () {}
    render(){





        return(
            <React.Fragment>
                <Helmet pageTitle="Interior Design" />
                <Header headertransparent="header--transparent" colorblack="color--black" logoname="logo.png" />

    
                {/* Start Finding Us Area  */}
                <div className="rn-finding-us-area attacment-fixed rn-finding-us ptb--120 bg_color--1 bg_image bg_image--navya" data-black-overlay="5">
                <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="rn-page-title text-center pt--100">
                                    <h2 className="title theme-gradient">Navya Bakeshop</h2>
                                  <p> Fresh bakery products including Fresh Cream Cakes, Savouries, Dry Cakes, Nuts and first bakery in Kerala to use only 100% natural colours and flavours.</p>
                                  <p className="theme-gradient"><Link to="/"> Home </Link> | <Link to="/package-des"> Previous </Link></p>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* End Finding Us Area  */}


                {/* Start Portfolio Area */}
                <div className="portfolio-area ptb--120 bg_color--1">
                    <div className="container">
                        <div className="row mt_dec--30">
                            {PortfolioList.map((value , index) => (
                                <div className="col-lg-4 col-md-4 col-12 mt--30" key={index}>
                                    <div className="im_portfolio">
                                        <div className="thumbnail_inner">
                                            <div className="thumbnail">
                                                <Link to="#">
                                                    {value.image}
                                                </Link>    
                                            </div>
                                        </div>
                                        <div className="content">
                                            <div className="inner">
                                                <div className="portfolio_heading">
                                                    <div className="category_list">
                                                        <Link to="#">{value.category}</Link>
                                                    </div>
                                                </div>
                                                <div className="portfolio_hover">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
                {/* End Portfolio Area */}



                 {/* Start Finding Us Area  */}
                 <div className="rn-finding-us-area attacment-fixed rn-finding-us ptb--120 bg_color--1 bg_image bg_image--navya" data-black-overlay="5">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-8 offset-lg-2">
                                <div className="inner">
                                    <div className="content-wrapper">
                                   
                                    </div>
                                </div>
                            </div>
                        </div> 
                    </div>
                </div>
                {/* End Finding Us Area  */}

                
                                {/* Start Portfolio Area */}
                                <div className="portfolio-area ptb--120 bg_color--1">
                    <div className="container">
                        <div className="row mt_dec--30">
                            {PortfolioList1.map((value , index) => (
                                <div className="col-lg-4 col-md-4 col-12 mt--30" key={index}>
                                    <div className="im_portfolio">
                                        <div className="thumbnail_inner">
                                            <div className="thumbnail">
                                                <Link to="#">
                                                    {value.image}
                                                </Link>    
                                            </div>
                                        </div>
                                        <div className="content">
                                            <div className="inner">
                                                <div className="portfolio_heading">
                                                    <div className="category_list">
                                                        <Link to="#">{value.category}</Link>
                                                    </div>
                                                </div>
                                                <div className="portfolio_hover">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
                {/* End Portfolio Area */}


                 {/* Start Footer Style  */}
                 <FooterTwo />
                {/* End Footer Style  */}

                {/* Start Back To Top */}
                <div className="backto-top">
                    <ScrollToTop showUnder={160}>
                        <FiChevronUp />
                    </ScrollToTop>
                </div>
                {/* End Back To Top */}
                </React.Fragment>
        )
    }
}

export default InteriorLanding;